import * as React from 'react';

const CropSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M7 7v10h10V7H7zm0-1h11v11h4v1h-4v4h-1v-4H6V7H2V6h4V2h1v4z" />
    </svg>
);

CropSvg.displayName = 'CropSvg';
export default CropSvg;
